export default {
  bugReport: 'Fehler melden',
  descriptionPlaceholder: 'Beschreiben Sie den Fehler',
  attachments: 'Anhänge',
  sendConfirmation: {
    summary: 'Fehlerbericht wurde versendet',
    detail: 'Wir haben Ihren Fehlerbericht erhalten und werden uns in kürze mit Ihnen in Verbidung setzen.',
  },
};
